import { Component, OnInit } from '@angular/core';
import { Subject } from "rxjs";
import { UserDataStoreService } from "../../../services/user-data-store.service";
import { MerchantService } from "../../../services/merchant.service";
import { PermissionEnum } from "../../../services/guards/permissions";
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { HttpClient } from '@angular/common/http';
import { CreateResult } from '../../../models/create-result';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CardAcceptorConfigViewModel } from '../../../models/card-acceptor-config-view-model';
import { CardAcceptorConfigService } from '../../../services/card-acceptor-config.service';
import { CountryViewModel } from '../../../models/country-view-model';
import { AddUpdateMerchantViewModel } from '../../../models/add-update-merchant-view-model';
import { TerminalService } from '../../../services/terminal.service';
import { ParticipantService } from "../../../services/participant.service";
import { ChangeDetectorRef } from '@angular/core';
import { TmCardAcceptorConfigViewModel } from '../../../models/tm-card-acceptor-model';
import { ConstantValues } from '../Common-helpers/constant-values';
import { validateFormHelper } from '../Common-helpers/validate-form';
import { IdTextPair } from '../../../models/id-text-pair';
import { merchantTerminalsLink } from '../../../models/merchant-terminals-link';
import { MerchantHidenControls } from '../../../models/merchant-hiden-controls';
import { Select2OptionData } from 'ng-select2';
import { MerchantSignedUpViewModel } from '../../../models/merchants-sign-up-view-model';
import { MerchantDetailModel } from '../../../models/merchant-detail-model';

@Component({
  selector: 'signup-merchant-component',
  templateUrl: './signup-merchant.component.html'
})

export class SignupMerchantComponent extends validateFormHelper implements OnInit {

  public addUpdateMerchant: AddUpdateMerchantViewModel;
  public display: MerchantHidenControls;
  private dtTrigger: Subject<boolean> = new Subject()
  private canEditMerchantSignUp = false;
  private cardAcceptorConfigList: CardAcceptorConfigViewModel[];
  private countryDetails: CountryViewModel;
  private defaultCardSet: string;
  public MerchantFormGroup: FormGroup;
  areaBuffer = [];
  bufferSize = 50;
  numberOfItemsFromEndBeforeFetchingMore = 10;
  loading = false;
  private formatSlipHeader: string;
  private formatSlipTrailer: string;
  private removePFIForAggregatorModel = false;
  private enableCustomNedbankPFI = false;
  private enableAbsaBase24SaPFI = false;
  public PostTerm: number = 2;
  public TermApp: number = 1;
  public termTypes: IdTextPair[] = [];
  public productProfiles: IdTextPair[] = [];
  public capabilityProfiles: IdTextPair[] = [];
  public capabilityCommsProductProfileProfiles: IdTextPair[] = [];
  public cardSets: IdTextPair[];
  public tmCardAcceptor: TmCardAcceptorConfigViewModel;
  public submitted: boolean;
  public governmentalOptions: IdTextPair[];
  public terminalDeliveryMethod: IdTextPair[] = [];
  public merchantTypes: IdTextPair[];
  public capabilityCommsProductProfile = [];
  public displayCountryCode = false;
  public cardAcceptorConfig: IdTextPair[];
  public countryCurrencyCode: string = "710";
  public _merchant: AddUpdateMerchantViewModel;
  public hidenControls: any;
  public areaData = [];
  public areaDataReserve = [];


  public merchantTypesIndicator: Select2OptionData[] = [
    { id: "New merchant", text: 'New merchant' },
    { id: "Existing merchant", text: 'Existing merchant' }
  ];
  public select2options: any = {
    multiple: false,
    width: '100%',
    allowClear: true
  };
  isExistingMerchant: boolean = false;
  col1isExistingMerchant: string;
  col7isExistingMerchant: string;
  displayMerchantIndicatorError: boolean = false;
  merchantDoesNotExistMessage: string;

  constructor(
    private _userDataStore: UserDataStoreService,
    private _terminalService: TerminalService,
    private _ngxUiLoaderService: NgxUiLoaderService,
    private _formBuilder: FormBuilder,
    public _cardAcceptorConfigService: CardAcceptorConfigService,
    private _merchantService: MerchantService,
    private _http: HttpClient,
    private _participantService: ParticipantService, private cdr: ChangeDetectorRef,
    private _merchantTerminalsLink: merchantTerminalsLink
  ) {
    super();
    this._ngxUiLoaderService.start();
    this.showElements("hidePFI");
    this.governmentalOptions = ConstantValues.governmentalOptions;
    this.terminalDeliveryMethod = ConstantValues.terminalDeliveryMethod;
    this.canEditMerchantSignUp = this._userDataStore.hasRequiredPermissions([PermissionEnum.EditMerchantSignUp]);
    this.col7isExistingMerchant = "col-8";
    this.col1isExistingMerchant = "";
    this._merchantTerminalsLink.merchantTypeIndicator = "New merchant";
    this._ngxUiLoaderService.stop();
  }

  public ngOnInit(): void {
    this.MerchantFormGroup = this._formBuilder.group({
      merchantTypeIndicator: ['', Validators.compose([Validators.required])],
      participantId: this._userDataStore.selectedParticipant.id,
      shopName: ['', Validators.compose([Validators.required, Validators.maxLength(23)])],
      merchantNumber: ['', Validators.compose([Validators.required, Validators.minLength(15), Validators.maxLength(23)])],
      cardAcceptorConfigId: ['', Validators.compose([Validators.required])],
      isGovernmentalMerchant: [false, Validators.compose([Validators.required])],
      cardSet: ['', Validators.compose([Validators.required])],
      countryCode: ['', Validators.compose([Validators.minLength(2)])],
      regionCode: ['', Validators.compose([Validators.required])],
      merchantType: ['', Validators.compose([Validators.required])],
      postalServiceCode: ['', Validators.compose([Validators.required])],
      city: ['', Validators.compose([Validators.required])],
      town: [''],
      slipTrailer: [''],
      slipHeader: [''],
      notes: [''],
      merchantVerificationValue: [''],
      merchantStreetAddress: [''],
      customerServicePhoneNo: [''],
      independentSalesOrgIdVisa: [''],
      independentSalesOrgId: [''],
      paymentFacilitatorIdVisa: [''],
      paymentFacilitatorId: [''],
      subMerchantId: [''],
    });
    this.governmentalOptions = ConstantValues.governmentalOptions;
    this.terminalDeliveryMethod = ConstantValues.terminalDeliveryMethod;
    this._merchant = this.MerchantFormGroup.value as AddUpdateMerchantViewModel;
    this.initObjects();
  }

  async ngAfterViewInit() {
    debugger;
    var country = await this._merchantService.GetDefaultCountry();
    const defaultCountry = country.countryCode;//'ZA';
    this.MerchantFormGroup.controls["countryCode"].setValue(defaultCountry);
    this.MerchantFormGroup.controls["merchantTypeIndicator"].setValue('New merchant');
    //this.MerchantFormGroup.controls["regionCode"].setValue('GP');
    this.onChangeCountry(country.countryCode);
    this.getCodes(country.country);
  }

  public getCodes(countryName: string) {
    let codePath: string = "";

    // Dynamically determine the path based on the country name or code
    switch (countryName) {
      case "South Africa":
        codePath = "assets/data/areas.json"
        break;
      case "Namibia":
        codePath = "assets/data/namibian_areas.json";
        break;
      default:
        codePath = "assets/data/areas.json";
    }

    this._http.get(codePath).subscribe((data: any[]) => {
      this.areaData = data;
      this.areaBuffer = this.areas.slice(0, this.bufferSize);
      this.areaDataReserve = data;
    });

    //clear selected city
    this.selectedArea = '';
  }

  public getCodes_old(countryDetails: CountryViewModel) {
    debugger;
    let codePath: string = "";
    switch (countryDetails.country) {
      case "South Africa":
        codePath = "assets/data/areas.json"
        break;
      case "Namibia":
        codePath = "assets/data/namibian_areas.json";
        break;
      default:
        codePath = "assets/data/areas.json"
    }

    this._http.get(codePath).subscribe((data: any[]) => {
      this.areas = data;
      this.areaBuffer = this.areas.slice(0, this.bufferSize);
    });
  }

  onChangeRegion(event) {
    this.MerchantFormGroup.controls["regionCode"].setValue(event);
    //Frans
  }

  public loadAreas(selectedId: string): void {
    debugger;

    const selectedRegion = this.regions.find(r => r.id === selectedId);
    const regionText = selectedRegion?.text;


    this.areaData = [];
    this.areaData = this.areaDataReserve;
    this.MerchantFormGroup.controls["regionCode"].setValue(selectedId);

    
    if (this.MerchantFormGroup.controls["countryCode"].value == "NA") {
      var list = this.areaData
        .filter(c => c.Region === regionText)
        //.filter(c => c.Area === 'Windhoek')
        //.map(c => ({ id: c.Suburb, text: c.Area }));
        .map(x => ({
          Suburb: x.Suburb, StrCode: x.StrCode, Area: x.Area
        }));
      //this.selectedArea
      this.areaData = list;
    }
  }


  public async initObjects(): Promise<void> {
    var participantId = this._userDataStore.selectedParticipant.id;
    this.countries = (await this._merchantService.GetCountries()).map((x) => {
      return { id: x.countryCode, text: x.country }
    });

    this.merchantTypes = (await this._merchantService.GetMerchantTypes()).map((x) => {
      return { id: x.code, text: `${x.code} - (${x.displayName})` }
    });

    this.cardAcceptorConfig = (await this._cardAcceptorConfigService.GetByParticipant(participantId)).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.cardSets = (await this._merchantService.GetCardSetsByParticipant(participantId)).map((x) => {
      return { id: x.cardSet, text: x.cardSet }
    });

    if (!this._userDataStore.selectedParticipant.removePFIDetails || this._userDataStore.selectedParticipant.removePFIDetails == null) {
      this.removePFIForAggregatorModel = false;
    }
    else {
      this.removePFIForAggregatorModel = true;
    }
    this.enableCustomNedbankPFI = await this._participantService.GetEnableCustomNedbankPFI();
    this.enableAbsaBase24SaPFI = await this._participantService.GetEnableAbsaBase24SaPFI();

    this.termTypes = (await this._terminalService.GetTermTypes()).map((x) => {
      return { id: x.id.toString(), text: x.name }
    });

    this.hidenControls = ConstantValues.hidenControls;
  }

  public async onNotesChange(event): Promise<void> {
  }

  public async onChangeCountry(event: string): Promise<void> {
    if (event !== '' && event !== undefined) {
      //Clear the data in the array
      this.regions = [];

      //Reset the Form
      this.MerchantFormGroup.controls['regionCode'].setValue(null);

      this.countryDetails = await this._merchantService.GetCountryDetails(event);
      debugger;

   
      var getRegions = await this._merchantService.GetRegionsByCountry(this.countryDetails?.country);//SA, NA
      if (getRegions == null) {
        this.regions = (await this._merchantService.GetRegions()).map((x) => {
          return { id: x.regionCode, text: x.regionName }
        });
      }
      else {
        this.regions = (getRegions).map((x) => {
          return { id: x.regionCode, text: x.regionName }
        });
      }

      this.getCodes(this.countryDetails?.country);
    }
  }

  onChangeMerchantTypeIndicator(value: string) {
    this.MerchantFormGroup.controls['merchantTypeIndicator'].setValue(value);

    if (value == "Existing merchant") {
      this.disableMerchantFormControls();
      this.isExistingMerchant = true;
      this.col7isExistingMerchant = "col-7";
      this.col1isExistingMerchant = "col-1";
      this._merchantTerminalsLink.merchantTypeIndicator = "Existing merchant";
    } else {
      this.enableFormControls();
      this.isExistingMerchant = false;
      this.col7isExistingMerchant = "col-8";
      this.col1isExistingMerchant = "";
      this.displayMerchantIndicatorError = false;

      this._merchantTerminalsLink.merchantTypeIndicator = "New merchant";
      this.MerchantFormGroup.controls['merchantTypeIndicator'].setValue(this.MerchantFormGroup.controls['merchantTypeIndicator'].value);
      this.MerchantFormGroup.controls['participantId'].setValue('');
      this.MerchantFormGroup.controls['shopName'].setValue('');
      this.MerchantFormGroup.controls['merchantNumber'].setValue('');
      this.MerchantFormGroup.controls['cardAcceptorConfigId'].setValue('');
      this.MerchantFormGroup.controls['isGovernmentalMerchant'].setValue('');
      this.MerchantFormGroup.controls['cardSet'].setValue('');
      this.MerchantFormGroup.controls['countryCode'].setValue('');
      this.MerchantFormGroup.controls['regionCode'].setValue('');
      this.MerchantFormGroup.controls['merchantType'].setValue('');
      this.MerchantFormGroup.controls['postalServiceCode'].setValue('');
      this.MerchantFormGroup.controls['city'].setValue('');
      this.MerchantFormGroup.controls['town'].setValue('');
      this.MerchantFormGroup.controls['slipTrailer'].setValue('');
      this.MerchantFormGroup.controls['slipHeader'].setValue('');
      this.MerchantFormGroup.controls['notes'].setValue('');
      this.MerchantFormGroup.controls['merchantVerificationValue'].setValue('');
      this.MerchantFormGroup.controls['merchantStreetAddress'].setValue('');
      this.MerchantFormGroup.controls['customerServicePhoneNo'].setValue('');
      this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].setValue('');
      this.MerchantFormGroup.controls['independentSalesOrgId'].setValue('');
      this.MerchantFormGroup.controls['paymentFacilitatorIdVisa'].setValue('');
      this.MerchantFormGroup.controls['paymentFacilitatorId'].setValue('');
      this.MerchantFormGroup.controls['subMerchantId'].setValue('');
    }
  }

  disableMerchantFormControls() {
    Object.keys(this.MerchantFormGroup.controls).forEach(key => {
      if (key != "merchantNumber" && key != "merchantTypeIndicator") {
        this.MerchantFormGroup.controls[key].disable();
      }
    });
  }

  enableFormControls() {
    Object.keys(this.MerchantFormGroup.controls).forEach(key => {
      this.MerchantFormGroup.controls[key].enable();
    });
  }

  clearFormControls() {
    Object.keys(this.MerchantFormGroup.controls).forEach(key => {
      if (key != "merchantNumber" && key != "merchantTypeIndicator") {
        this.MerchantFormGroup.controls[key].setValue('');
      }
    });
  }

  async searchMerchant() {
    this._ngxUiLoaderService.start();
    if (this.MerchantFormGroup.controls['merchantNumber'].value == null || this.MerchantFormGroup.controls['merchantNumber'].value == '' || this.MerchantFormGroup.controls['merchantNumber'].value.length < 15) {
      this.submitted = true;
    }
    else {

      this.addUpdateMerchant = await this._merchantService.Get(this.MerchantFormGroup.controls['merchantNumber'].value);

      if (this.addUpdateMerchant == null) {
        this.displayMerchantIndicatorError = true;
        this.merchantDoesNotExistMessage = "Merchant does not exist.";
        this.clearFormControls();
        this._ngxUiLoaderService.stop();
        return;
      }

      if (this.addUpdateMerchant.participantId != this._userDataStore.selectedParticipant.id) {
        this.displayMerchantIndicatorError = true;
        this.merchantDoesNotExistMessage = "Merchant does not belong to your estate.";
        this.clearFormControls();

      }
      else {
        debugger;
        this.displayMerchantIndicatorError = false;
        this.merchantDoesNotExistMessage = "";
        this.MerchantFormGroup.controls['merchantTypeIndicator'].setValue(this.MerchantFormGroup.controls['merchantTypeIndicator'].value);
        this.MerchantFormGroup.controls['participantId'].setValue(this._userDataStore.selectedParticipant.id);
        this.MerchantFormGroup.controls['shopName'].setValue(this.addUpdateMerchant.shopName);
        this.MerchantFormGroup.controls['merchantNumber'].setValue(this.addUpdateMerchant.merchantNumber);
        this.MerchantFormGroup.controls['cardAcceptorConfigId'].setValue(this.addUpdateMerchant.cardAcceptorConfigId);
        this.MerchantFormGroup.controls['isGovernmentalMerchant'].setValue(this.addUpdateMerchant.isGovernmentalMerchant == true ? 'Yes' : 'No');
        this.MerchantFormGroup.controls['cardSet'].setValue(this.addUpdateMerchant.cardSet);
        this.MerchantFormGroup.controls['countryCode'].setValue(this.addUpdateMerchant.countryCode);
        this.MerchantFormGroup.controls['regionCode'].setValue(this.addUpdateMerchant.regionCode);
        this.MerchantFormGroup.controls['merchantType'].setValue(this.addUpdateMerchant.merchantType);
        this.MerchantFormGroup.controls['city'].setValue(this.addUpdateMerchant.city);
        this.MerchantFormGroup.controls['town'].setValue(this.addUpdateMerchant.town);
        this.MerchantFormGroup.controls['slipTrailer'].setValue(this.addUpdateMerchant.slipTrailer);
        this.MerchantFormGroup.controls['slipHeader'].setValue(this.addUpdateMerchant.slipHeader);
        this.MerchantFormGroup.controls['notes'].setValue('');
        this.MerchantFormGroup.controls['merchantVerificationValue'].setValue(this.addUpdateMerchant.merchantVerificationValue);
        debugger;
        this.MerchantFormGroup.controls['merchantStreetAddress'].setValue(this.addUpdateMerchant.merchantStreetAddress);
        this.MerchantFormGroup.controls['customerServicePhoneNo'].setValue(this.addUpdateMerchant.customerServicePhoneNo);
        this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].setValue(this.addUpdateMerchant.independentSalesOrgIdVisa);
        this.MerchantFormGroup.controls['independentSalesOrgId'].setValue(this.addUpdateMerchant.independentSalesOrgId);
        this.MerchantFormGroup.controls['paymentFacilitatorIdVisa'].setValue(this.addUpdateMerchant.paymentFacilitatorIdVisa);
        this.MerchantFormGroup.controls['paymentFacilitatorId'].setValue(this.addUpdateMerchant.paymentFacilitatorId);
        this.MerchantFormGroup.controls['subMerchantId'].setValue(this.addUpdateMerchant.subMerchantId);
        this.MerchantFormGroup.controls["postalServiceCode"].setValue(this.addUpdateMerchant.postalServiceCode);
        this._merchantTerminalsLink.merchantTypeIndicator = "Existing merchant";

        if (this._merchantTerminalsLink?.merchant == null) {
          this._merchantTerminalsLink.merchant = this.MerchantFormGroup.value as AddUpdateMerchantViewModel;
        }
        this._merchantTerminalsLink.merchant.merchantStreetAddress = this.addUpdateMerchant.merchantStreetAddress;
        this._merchantTerminalsLink.merchant.regionCode = this.addUpdateMerchant.regionCode;
        this._merchantTerminalsLink.merchant.postalServiceCode = this.addUpdateMerchant.postalServiceCode;
        this._merchantTerminalsLink.merchant.countryCode = this.addUpdateMerchant.countryCode;
        this._merchantTerminalsLink.merchant.city = this.addUpdateMerchant.city;
        this._merchantTerminalsLink.merchant.town = this.addUpdateMerchant.town;
        this._merchantTerminalsLink.merchant.customerServicePhoneNo = this.addUpdateMerchant.customerServicePhoneNo;
        this._merchantTerminalsLink.merchant.shopName = this.addUpdateMerchant.shopName;
        this._merchantTerminalsLink.merchant.merchantNumber = this.addUpdateMerchant.merchantNumber;
        this._merchantTerminalsLink.merchant.cardAcceptorConfigId = this.addUpdateMerchant.cardAcceptorConfigId;
        this._merchantTerminalsLink.merchant.isGovernmentalMerchant = this.addUpdateMerchant.isGovernmentalMerchant;// == true ? 'Yes' : 'No');
        this._merchantTerminalsLink.merchant.cardSet = this.addUpdateMerchant.cardSet;
        this._merchantTerminalsLink.merchant.countryCode = this.addUpdateMerchant.countryCode;
        this._merchantTerminalsLink.merchant.regionCode = this.addUpdateMerchant.regionCode;
        this._merchantTerminalsLink.merchant.merchantType = this.addUpdateMerchant.merchantType;
        this._merchantTerminalsLink.merchant.city = this.addUpdateMerchant.city;
        this._merchantTerminalsLink.merchant.slipTrailer = this.addUpdateMerchant.slipHeader;
        this._merchantTerminalsLink.merchant.slipHeader = this.addUpdateMerchant.slipTrailer;
        this._merchantTerminalsLink.notes = '';
        this._merchantTerminalsLink.merchant.merchantVerificationValue = this.addUpdateMerchant.merchantVerificationValue;
        this._merchantTerminalsLink.merchant.independentSalesOrgIdVisa = this.addUpdateMerchant.independentSalesOrgIdVisa;
        this._merchantTerminalsLink.merchant.independentSalesOrgId = this.addUpdateMerchant.independentSalesOrgId;
        this._merchantTerminalsLink.merchant.paymentFacilitatorIdVisa = this.addUpdateMerchant.paymentFacilitatorIdVisa;
        this._merchantTerminalsLink.merchant.paymentFacilitatorId = this.addUpdateMerchant.paymentFacilitatorId;
        this._merchantTerminalsLink.merchant.subMerchantId = this.addUpdateMerchant.subMerchantId;
        this._merchantTerminalsLink.merchant.participantId = this._userDataStore.selectedParticipant.id;

        if (this.MerchantFormGroup.controls['merchantStreetAddress'].value == '' || this.MerchantFormGroup.controls['merchantStreetAddress'].value == null) {
          this.MerchantFormGroup.controls['merchantStreetAddress'].enable();
        }

      }

    }

    this._ngxUiLoaderService.stop();
  }
  
  onChangeCity(cityValue) {
    if (cityValue != null && cityValue != '' && cityValue != undefined) {
      if (cityValue['StrCode'] != null && cityValue['StrCode'] != '' && cityValue['StrCode'] != undefined) {
        this.MerchantFormGroup.controls["postalServiceCode"].setValue(cityValue['StrCode']?.slice(0, 4));
      } else {
        this.MerchantFormGroup.controls["postalServiceCode"].setValue(cityValue['BoxCode']?.slice(0, 4));
      }
    }
  }

  onChangeMerchantType(cityValue) {
  }

  public async onMerchantConfig(): Promise<void> {
    this.hidenControls = ConstantValues.hidenControls;
    this.cardAcceptorConfigList = await this._cardAcceptorConfigService.GetAllConfigs();

    const selectedCardAcceptorConfig = this.cardAcceptorConfig.find((x) => {
      return +x.id == this.MerchantFormGroup.controls['cardAcceptorConfigId'].value
    });

    const cardAcceptorConfig = this.cardAcceptorConfigList.find((x) => {
      return selectedCardAcceptorConfig && x.name == selectedCardAcceptorConfig.text
    });

    if (cardAcceptorConfig != undefined) {
      var participantDetails = await this._participantService.GetAggregateMerchant(this._userDataStore.selectedParticipant.id);
      if (cardAcceptorConfig.routingGroup.includes("ABSA")) {

        if (participantDetails.absaO1Token) {
          this.showElements("absaToken");
        }
        else if (!this.enableAbsaBase24SaPFI) {
          this.showElements("AbsaConfig");
        }
        else if (this.enableAbsaBase24SaPFI) {
          this.showElements("AbsaForBase24");
        }
      }
      else if (participantDetails.isAggregator) {

        if (this.enableCustomNedbankPFI && (cardAcceptorConfig.routingGroup.includes("Nedbank") || cardAcceptorConfig.routingGroup.includes("NedPost")
          || cardAcceptorConfig.routingGroup.includes("NedPB_RG") || cardAcceptorConfig.routingGroup.includes("Ned"))) {
          this.showElements("NedbankConfig");
        }
        else {
          if (participantDetails.removePFIDetails == null || participantDetails.removePFIDetails == false || participantDetails.removePFIDetails == true) {

            if (participantDetails.removePFIDetails == true) {
              this.showElements("hidePFI");
            }
            else {
              this.showElements("AbsaConfig"); ("AbsaConfig");
            }
          }
        }
      }
      else {
        this.showElements("hidePFI");
      }
    }
  };

  showElements(name) {

    this.display = {
      customerServicePhoneNo: false,
      merchantStreetAddress: true,
      independentSalesOrgId: false,
      paymentFacilitatorIdVisa: false,
      paymentFacilitatorId: false,
      subMerchantId: false,
      independentSalesOrgIdVisa: false,
      merchantVerificationValue: false
    }

    switch (name) {

      case "AbsaTokenConfig": {
        this.display.customerServicePhoneNo = true;
        break;
      }
      case "AbsaConfig": {
        this.display.subMerchantId = true;
        this.display.independentSalesOrgId = true;
        this.display.paymentFacilitatorId = true;
        this.display.paymentFacilitatorIdVisa = true;
        this.display.customerServicePhoneNo = true;
        //ISO ID Visa
        if ((this._userDataStore.selectedParticipant.isAggregator == false || this._userDataStore.selectedParticipant.isAggregator == null)) {
          this.display.independentSalesOrgIdVisa = true;
        }
        else {
          this.display.independentSalesOrgIdVisa = false;
          this.MerchantFormGroup.controls["independentSalesOrgId"].setValue('00000000000');
        }
        break;
      }
      case "AbsaForBase24": {

        this.display.independentSalesOrgId = true;
        this.display.paymentFacilitatorId = true;
        this.display.customerServicePhoneNo = true;
        if ((this._userDataStore.selectedParticipant.isAggregator == false || this._userDataStore.selectedParticipant.isAggregator == null)) {
          this.display.independentSalesOrgIdVisa = false;
          this.display.subMerchantId = true;
          this.display.paymentFacilitatorIdVisa = true;
        }
        else {
          this.MerchantFormGroup.controls["independentSalesOrgId"].setValue('00000000000');
          this.display.independentSalesOrgIdVisa = true;
          this.display.subMerchantId = false;
          this.display.paymentFacilitatorIdVisa = false;
        }
        break;
      }
      case "NedbankConfig":
        {
          this.display.subMerchantId = true;
          this.display.paymentFacilitatorId = true;
          this.display.merchantVerificationValue = true;
        }
        break;
      case "OtherBanksConfig":
        {
          this.display.subMerchantId = true;
          this.display.paymentFacilitatorId = true;
          this.display.merchantVerificationValue = true;
        }
        break;
      case "Aggregator":
        {
          this.display.customerServicePhoneNo = true;
          this.display.independentSalesOrgId = true;
          this.display.paymentFacilitatorIdVisa = true;
          this.display.paymentFacilitatorId = true;
          this.display.subMerchantId = true;
        }
        break;
      case "hidePFI":
        {
          this.display.customerServicePhoneNo = false;
          this.display.independentSalesOrgId = false;
          this.display.paymentFacilitatorIdVisa = false;
          this.display.paymentFacilitatorId = false;
          this.display.subMerchantId = false;
          this.display.independentSalesOrgIdVisa = false;
          this.display.merchantVerificationValue = false;
        }
      default:
        break
    }

    if (this.MerchantFormGroup !== undefined) {
      this.setValidators();
    }
  }

  public setValidators() {

    let _setValidators = {
      merchantVerificationValue: [Validators.required, Validators.minLength(10), Validators.maxLength(10)],
      merchantStreetAddress: [Validators.required, Validators.compose([Validators.required])],
      customerServicePhoneNo: [Validators.required, Validators.compose([Validators.minLength(11), Validators.maxLength(11)])],
      independentSalesOrgIdVisa: [Validators.required, Validators.compose([Validators.minLength(11), Validators.maxLength(11)])],
      independentSalesOrgId: [Validators.required, Validators.compose([Validators.minLength(11), Validators.maxLength(11)])],
      paymentFacilitatorIdVisa: [Validators.required, Validators.compose([Validators.maxLength(11)])],
      paymentFacilitatorId: [Validators.required, Validators.compose([Validators.maxLength(11)])],
      subMerchantId: [Validators.required, Validators.compose([Validators.minLength(15), Validators.maxLength(15)])],
    }

    for (const prop of this.hidenControls) {
      this.MerchantFormGroup.get(prop).setValidators(_setValidators[prop])
      this.MerchantFormGroup.get(prop).updateValueAndValidity();
    }

    for (const prop of this.hidenControls) {
      if (this.display[prop] === false) {
        this.MerchantFormGroup.get(prop).clearValidators();
        this.MerchantFormGroup.get(prop).updateValueAndValidity();
      }
    }
  }

  public setMerchantData(): AddUpdateMerchantViewModel {
    debugger;
    if (this._merchant == null) {
      this._merchant = this.MerchantFormGroup.value as AddUpdateMerchantViewModel
    }
    this._merchant.isGovernmentalMerchant = this.MerchantFormGroup.controls['isGovernmentalMerchant'].value == "Yes" ? true : false;
    this._merchant.city = this.MerchantFormGroup.controls['city'].value['Area'];

    //populate merchant object
    this._merchant.participantId = this.MerchantFormGroup.controls['participantId'].value;
    this._merchant.shopName = this.MerchantFormGroup.controls['shopName'].value;
    this._merchant.merchantNumber = this.MerchantFormGroup.controls['merchantNumber'].value;
    this._merchant.cardAcceptorConfigId = this.MerchantFormGroup.controls['cardAcceptorConfigId'].value;
    this._merchant.cardSet = this.MerchantFormGroup.controls['cardSet'].value;
    this._merchant.countryCode = this.MerchantFormGroup.controls['countryCode'].value;
    this._merchant.regionCode = this.MerchantFormGroup.controls['regionCode'].value;
    this._merchant.town = this.MerchantFormGroup.controls['town'].value;
    this._merchant.merchantType = this.MerchantFormGroup.controls['merchantType'].value;
    this._merchant.postalServiceCode = this.MerchantFormGroup.controls['postalServiceCode'].value;
    //this._merchant.slipTrailer = this.MerchantFormGroup.controls['slipTrailer'].value;frans
    //this._merchant.slipHeader = this.MerchantFormGroup.controls['slipHeader'].value;
    this._merchant.merchantVerificationValue = this.MerchantFormGroup.controls['merchantVerificationValue'].value;
    this._merchant.customerServicePhoneNo = this.MerchantFormGroup.controls['customerServicePhoneNo'].value;
    this._merchant.independentSalesOrgIdVisa = this.MerchantFormGroup.controls['independentSalesOrgIdVisa'].value;
    this._merchant.independentSalesOrgId = this.MerchantFormGroup.controls['independentSalesOrgId'].value;
    this._merchant.paymentFacilitatorIdVisa = this.MerchantFormGroup.controls['paymentFacilitatorIdVisa'].value;
    this._merchant.paymentFacilitatorId = this.MerchantFormGroup.controls['paymentFacilitatorId'].value;
    this._merchant.subMerchantId = this.MerchantFormGroup.controls['subMerchantId'].value;
    this._merchant.merchantStreetAddress = this.MerchantFormGroup.controls['merchantStreetAddress'].value;

    if (this._merchantTerminalsLink?.merchant == null) {
      this._merchantTerminalsLink.merchant = this._merchant;
      this._merchantTerminalsLink.merchantTypeIndicator = this.MerchantFormGroup.controls["merchantTypeIndicator"].value;
    }
    else {
      this._merchantTerminalsLink.merchant.merchantStreetAddress = this._merchant.merchantStreetAddress;
    }

    this._merchantTerminalsLink.commonData = {
      getCodes: this.getCodes,
      termTypes: this.termTypes,
      productProfiles: this.productProfiles,
      capabilityProfiles: this.capabilityProfiles,
    };

    this._merchantTerminalsLink.locationData = {
      countries: this.countries,
      regions: this.regions,
      areas: this.areas,
    } as any;

    this._merchantTerminalsLink.notes = this.MerchantFormGroup.controls['notes'].value;
    return (this._merchant);
  }

  async validateForm(): Promise<CreateResult> {

    this.MerchantFormGroup.updateValueAndValidity();

    if (this.MerchantFormGroup.valid) {

      var merchantType = this.MerchantFormGroup.controls['merchantTypeIndicator'].value;
      var merchant = (await this._merchantService.GetTmCardAcceptor(this.MerchantFormGroup.controls['merchantNumber'].value));

      if (this.MerchantFormGroup.controls['merchantTypeIndicator'].value == 'New merchant') {
        if (merchant == null) {
          this.setMerchantData();
          return this.hasValideResponse({ message: ``, success: true } as CreateResult);
        }
        if (merchant != null) {
          return this.hasValideResponse({ message: `Merchant ${this.MerchantFormGroup.controls['merchantNumber'].value} already exist`, success: false } as CreateResult);
        }
      }
      if (this.MerchantFormGroup.controls['merchantTypeIndicator'].value == 'Existing merchant') {
        if (merchant == null) {
          return this.hasValideResponse({ message: `Merchant ${this.MerchantFormGroup.controls['merchantNumber'].value} does not exist`, success: false } as CreateResult);
        }
        if (merchant != null) {
          this.setMerchantData();
          return this.hasValideResponse({ message: ``, success: true } as CreateResult);
        }
      }
    }
    return this.formValidation(this.MerchantFormGroup, {
      message: "Merchant details is invalid, Please fill all requered fields",
      success: false
    });

  }

  public displayAdditionaControls(index: number): boolean {
    return false;
  }

  public ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  public async isGovernmental(): Promise<void> {
    this.displayCountryCode = false;
    this.countryCurrencyCode = "   ";
    if (this.MerchantFormGroup.controls["isGovernmentalMerchant"].value == "Yes") {
      this.displayCountryCode = true;
      this.countryCurrencyCode = "710";
    }
  }

  public formatThisText(event: string) {
    this.formatSlipHeader = event.replace(/\n/g, "\\n");
  }

  public onSlipHeaderChange(value: string) {

    this.formatSlipHeader = "" + this.formatNotes(value);
    this.MerchantFormGroup.controls["slipHeader"].setValue(this.formatSlipHeader);
    this._merchant.slipHeader = this.formatSH(this.formatSlipHeader);

  }

  public onSlipTrailerChange(value: string) {
    this.formatSlipTrailer = "" + this.formatNotes(value);
    this.MerchantFormGroup.controls["slipTrailer"].setValue(this.formatSlipTrailer);
    this._merchant.slipTrailer = this.formatSH(this.formatSlipTrailer);
  }

  formatNotes = (value: String): String => {

    const escapedValue = value.replace(/\n/g, "\\n");

    // Split the input value by newlines
    const lines = escapedValue.split('\\n');

    const formattedText = lines.map((line) => {
      var format_input = line.length > 24 ? line.slice(0, 24) + '\n' + line.slice(24) : line;
      return format_input;
    });

    return formattedText.join('\n');
  }

  formatSH(slipHeader: string): string {
    const lines = slipHeader.split('\n');
    if (lines.length > 1) {

      const formattedText = lines.map((line) => {
        var format_input = line + '\\n';
        return format_input;
      });
      var response1 = formattedText.join();
      var response2 = formattedText.join(' ');
      return response2;
      //return slipHeader.replace('\n', "\\n");

    }
    return slipHeader.replace('\n', "\\n");
  }

  formatST(slipTrailer: string): string {
    const lines = slipTrailer.split('\n');
    if (lines.length > 1) {

      const formattedText = lines.map((line) => {
        var format_input = line + '\\n';
        return format_input;
      });
      var response1 = formattedText.join();
      var response2 = formattedText.join(' ');
      return response2;

    }
    return slipTrailer.replace('\n', "\\n");
  }

  public async getMerchantSignUp(merchantNumber: string) {
    return await this._merchantService.GetMerchantSignedUp(merchantNumber);
  }

  public async getMerchant(merchantNumber: string) {
    return await this._merchantService.GetMerchantDetails(merchantNumber);
  }

  public async updateMerchant(merchant: MerchantDetailModel) {
    merchant.merchantStreetAddress = this.MerchantFormGroup.controls["merchantStreetAddress"].value;
    return await this._merchantService.updateMerchant(merchant);
  }

  public async addUpdateMerchantSignUp(merchant: merchantTerminalsLink): Promise<CreateResult> {
    const date: Date = new Date();

    var addMerchantSignUp: MerchantSignedUpViewModel = {
      merchantNumber: merchant.merchant.merchantNumber,
      changedBy: '',
      changedOn: date,
      deliveryMethod: '',
      dispatch: false,
      inUseBy: '',
      inUseById: '',
      inUseDate: date,
      participantId: merchant.merchant.participantId,
      shopName: merchant.merchant.shopName,
      source: '',
      status: 'New',
      userId: '',
      id: 1
    }
    var createResult: CreateResult = await this._merchantService.AddMerchantSignUp(addMerchantSignUp);
    return createResult;
  }

  public omitSpecialChar(event) {
    let c = event.charCode;
    if ((c > 64 && c < 91) || (c > 96 && c < 123) || c == 8 || c == 32 || (c >= 48 && c <= 57) || c == 42 || c != 13) {
      this.MerchantFormGroup.controls["shopName"].reset(event.target.value);
    }
  }

  public omitSpecialCharAddress(event) {
    let c = event.charCode;//         c = event.keyCode;  (Both can be used)
    return ((c > 64 && c < 91) || (c > 96 && c < 123) || c == 8 || c == 32 || (c >= 48 && c <= 57) || c == 44);
  }

  onScrollToEnd() {
    const len = this.areaBuffer.length;
    const more = this.areas.slice(len, this.bufferSize + len);
    this.loading = true;
    // using timeout here to simulate backend API delay
    setTimeout(() => {
      this.loading = false;
      this.areaBuffer = this.areaBuffer.concat(more);
    }, 200)
  }

  onScroll({ end }) {
    if (this.loading || this.areas.length <= this.areaBuffer.length) {
      return;
    }

    if (end + this.numberOfItemsFromEndBeforeFetchingMore >= this.areaBuffer.length) {
      this.onScrollToEnd()
    }
  }

  public async saveAsync(): Promise<CreateResult> {
    return await this._merchantService.Add(this._merchant);
  }
}


